import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AdminChatService } from './admin-chat.service';

@Component({
  selector: 'soporte-chat-admin',
  templateUrl: './soporte-chat-admin.component.html',
  styleUrls: ['./soporte-chat-admin.component.css']
})
export class SoporteChatAdminComponent implements OnInit{

  constructor(public chatService: AdminChatService) { }

  conversaciones;
  id;
  chatSeleccionado;
  chatActual;
  mensaje = "";

  ngOnInit() {
    this.chatService.subscribeToChats();
  }

  getChat(id) {
    this.chatService.getChat(id).subscribe( async (snap) => {
      this.chatActual = snap.payload.data();
    }); 
  }
  
  cambiarId(id, i) {
    this.id = id;
    this.chatSeleccionado = i;
  }

  enviarMensaje(id) {
    this.chatService.leido(id)
    this.chatService.pushMessage(
      id,
      {
        usuario: "Soporte Predyc",
        mensaje: this.mensaje,
        admin: true,
      }
    )
    this.mensaje = "";
  }

  cambiarStatus(){
    this.chatService.actualizarStatus(this.chatActual.id,this.chatActual.status);
  }


}
